<template>
  <b-dropdown :value="value" @input="onOptionSelected" aria-role="list">
    <!-- Button-->
    <button class="button" type="button" slot="trigger">
      <b-icon icon="calendar"></b-icon>
      <span>
        <span class="has-text-grey-light">Scope:</span> {{ selectedOption.label }}
      </span>
      <b-icon icon="menu-down"></b-icon>
    </button>

    <!-- Options to choose-->
    <b-dropdown-item v-for="o in options" :key="o.value" :value="o.startTime" aria-role="listitem">
      {{ o.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
  import { CHART_PRESETS } from '@/const'

  export default {
    name: "ChartScopeSelector",
    props: {
      value: { type: String, required: true }
    },
    data() {
      return {
        options: CHART_PRESETS
      }
    },
    computed: {
      selectedOption () {
        return this.options.find(o => o.startTime === this.value)
      }
    },
    methods: {
      onOptionSelected(value) {
        this.$emit('input', this.options.find(o => o.startTime === value))
      }
    }
  }
</script>
